import { Model, model, prop } from "mobx-keystone";
import {
  APIFormulationApprovalCategory,
  APIFormulationApprovalComment,
  APIFormulationApprover,
} from "../../api/formulationApprovals";

@model("collab/FormulationApproval")
class FormulationApproval extends Model({
  id: prop<identifier>(),
  projectId: prop<identifier>(),
  projectName: prop<identifier>(),
  status: prop<"pending" | "resubmit" | "completed">(),
  requestedBy: prop<APIFormulationApprover>(),
  requestedAt: prop<string>(),
  categories: prop<APIFormulationApprovalCategory[]>(() => []),
  comments: prop<APIFormulationApprovalComment[]>(() => []),
}) {}

export default FormulationApproval;
